var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat, } from "../../UI/FormFormat/FormFormat";
import AddPopulationToFolderForm from "./AddPopulationToFolderForm";
import FolderService from "../../../Services/Folder.service";
const AddPopulationToFolderModal = (_a) => {
    var { folders, currentFolder, onSuccess, populationId } = _a, modalProps = __rest(_a, ["folders", "currentFolder", "onSuccess", "populationId"]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Add Filter to Folder", onSuccess: onSuccess, handleSubmit: (state) => FolderService.addPopulationToFolder(state.folder.id, populationId), children: _jsx(AddPopulationToFolderForm, { required: true, folders: folders, currentFolder: currentFolder }) })));
};
export default AddPopulationToFolderModal;
